export const fetchResultadoOptions = async () => [
  { key: 'true', value: 'Aprovado' },
  { key: 'false', value: 'Rejeitado' },
]

